import { getLocal, setLocal } from './utilsSocial';

export const UI_THEME_KEY = 'uiTheme';
// export const UI_THEME_SYSTEM = 'system';
export const UI_THEME_SYSTEM = 'light';
export const UI_THEME_LIGHT = 'light';
export const UI_THEME_DARK = 'dark';

const VALID = new Set([UI_THEME_SYSTEM, UI_THEME_LIGHT, UI_THEME_DARK]);

let lastDesign = null;
let mediaListenerBound = false;
let designThemeApplier = null;
let applyingUiTheme = false;
let lastAppliedResolved = null;
let lastAppliedPref = null;

export const getUiThemePreference = () => {
  const stored = getLocal(UI_THEME_KEY);
  if (VALID.has(stored)) return stored;
  return UI_THEME_SYSTEM;
};

export const setUiThemePreference = (preference) => {
  const next = VALID.has(preference) ? preference : UI_THEME_SYSTEM;
  setLocal(UI_THEME_KEY, next);
  return next;
};

export const resolveUiTheme = (preference = getUiThemePreference()) => {
  if (preference === UI_THEME_LIGHT || preference === UI_THEME_DARK) {
    return preference;
  }
  if (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return UI_THEME_DARK;
  }
  return UI_THEME_LIGHT;
};

export const rememberDesignForTheme = (design) => {
  lastDesign = design || null;
};

export const getLastDesignForTheme = () => lastDesign;

export const registerDesignThemeApplier = (fn) => {
  designThemeApplier = fn;
};

export const applyUiTheme = (preference = getUiThemePreference()) => {
  if (typeof document === 'undefined') return resolveUiTheme(preference);
  if (applyingUiTheme) return lastAppliedResolved || resolveUiTheme(preference);

  const pref = VALID.has(preference) ? preference : UI_THEME_SYSTEM;
  const resolved = resolveUiTheme(pref);

  // Avoid redundant DOM writes that can retrigger observers / Safari style storms
  if (resolved === lastAppliedResolved && pref === lastAppliedPref) {
    return resolved;
  }

  applyingUiTheme = true;
  try {
    document.documentElement.dataset.theme = resolved;
    document.documentElement.dataset.themePref = pref;
    // color-scheme is set via CSS (variables.css) — do not set style.colorScheme here;
    // on some WebKit builds it interacts badly with prefers-color-scheme listeners.

    lastAppliedResolved = resolved;
    lastAppliedPref = pref;

    if (typeof designThemeApplier === 'function') {
      designThemeApplier(lastDesign);
    }
  } finally {
    applyingUiTheme = false;
  }

  return resolved;
};

export const bindSystemThemeListener = () => {
  if (mediaListenerBound || typeof window === 'undefined') return;
  mediaListenerBound = true;

  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const onChange = () => {
    if (getUiThemePreference() !== UI_THEME_SYSTEM) return;
    // Reset memo so system flips actually apply
    lastAppliedResolved = null;
    applyUiTheme(UI_THEME_SYSTEM);
  };

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', onChange);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(onChange);
  }
};
